import React from 'react';

import { Heading8 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledTitleBadge } from './styles';

const b = bemClassName('title-badge');

const TitleBadge = ({ text }) => {
  return (
    <StyledTitleBadge>
      <span className={b()}>
        <Heading8>{text}</Heading8>
      </span>
    </StyledTitleBadge>
  );
};

export default TitleBadge;
